import React from 'react';
import { cn } from '@/utils/utils';
import NotificationSheet, {
  useToggleNotificationSheet,
  useUnreadNotificationCount,
} from '@/components/Layout/NotificationMenu';
import { BilderitLogoHorizontal } from '@/components/BilderitLogoHorizontal';
import { ModeToggle } from '@/components/mode-toggle';
import UserMenu from '@/components/Layout/UserMenu';
import { BellIcon, Badge } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const MachinistHeader = () => {
  const toggleNotificationSheet = useToggleNotificationSheet();
  const unreadNotificationCount = useUnreadNotificationCount();

  return (
    <div
      className={cn(
        'flex sticky w-full bg-background p-3 shadow-md justify-between items-center'
      )}
    >
      <NotificationSheet side="right" />
      <BilderitLogoHorizontal style={{ height: '2.5rem' }} />
      <span className="flex flex-row items-center gap-2">
        <ModeToggle
        // className="bg-sidebar-accent hover:bg-sidebar-border"
        />
        <Button
          variant="outline"
          size="icon"
          className="relative bg-transparent hover:bg-black/10 dark:hover:bg-white/10"
          onClick={toggleNotificationSheet}
        >
          <BellIcon className="size-5" />
          {!!unreadNotificationCount && (
            <Badge className="absolute -right-2 -top-2 size-5 p-0 flex items-center justify-center bg-yellow-400 text-black">
              {unreadNotificationCount}
            </Badge>
          )}
          <span className="sr-only">Notificaciones</span>
        </Button>

        <UserMenu
        // className="bg-sidebar-accent hover:bg-sidebar-border"
        />
      </span>
    </div>
  );
};
